/* @flow */
import { call, put } from 'redux-saga/effects';
import ReactionEmojis from 'collections/ReactionEmojis';

export default function* loadAvailableReactions(): Generator<?any, ?any, ?any> {
  try {
    const availableReactions = yield call(ReactionEmojis.fetch);
    if (availableReactions) {
      yield put({
        type: 'availableReactions/LOAD_REACTIONS_SUCCESS',
        availableReactions,
      });
    }
  } catch (e) {
    console.warn(e);
  }
}



// WEBPACK FOOTER //
// ./src/sagas/availableReactions.js